import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useControlledState } from '@prophecy/utils/react/hooks';
import React, { useId } from 'react';
import { CheckIcon, MinusIcon } from '../Icons';
import { Stack } from '../Layout';
import { theme } from '../theme/index';
import { renderWithTooltip } from '../Tooltip';
import { LabelWithHint } from '../Typography/LabelWithHint';
import { StyledCheckboxRoot, StyledCheckboxIndicator, CheckboxLabel, StyledHelpText } from './styled';
import { Size } from './types';
export const Checkbox = ({ checked, defaultChecked, indeterminate, disabled, onChange, children, size = Size.s, hint, tooltip, helpText, 'data-test-id': dataTestId, 'aria-label': ariaLabel, id: propId, ...restProps })=>{
    const generatedId = useId();
    const checkboxId = propId ?? generatedId;
    const [checkedState, setCheckedState] = useControlledState({
        value: indeterminate ? 'indeterminate' : checked,
        defaultValue: defaultChecked,
        onChange: (value)=>onChange?.(value)
    });
    let checkBoxUI = /*#__PURE__*/ _jsx(StyledCheckboxRoot, {
        id: checkboxId,
        checked: !!checkedState,
        size: size,
        defaultChecked: !!defaultChecked,
        onCheckedChange: setCheckedState,
        disabled: Boolean(disabled),
        $indeterminate: checkedState === 'indeterminate',
        "aria-label": ariaLabel,
        "data-test-id": dataTestId,
        ...restProps,
        children: /*#__PURE__*/ _jsxs(StyledCheckboxIndicator, {
            children: [
                checkedState === 'indeterminate' && /*#__PURE__*/ _jsx(MinusIcon, {
                    type: "default",
                    size: size
                }),
                checkedState === true && /*#__PURE__*/ _jsx(CheckIcon, {
                    type: "default",
                    size: size
                })
            ]
        })
    });
    if (hint && !children) {
        checkBoxUI = /*#__PURE__*/ _jsx(LabelWithHint, {
            hint: hint,
            children: checkBoxUI
        });
    }
    const childrenUI = hint && children ? /*#__PURE__*/ _jsx(LabelWithHint, {
        hint: hint,
        children: children
    }) : children;
    const checkboxContent = /*#__PURE__*/ _jsxs(Stack, {
        gap: theme.spaces.x2,
        children: [
            /*#__PURE__*/ _jsxs(Stack, {
                direction: "horizontal",
                gap: theme.spaces.x8,
                alignY: "center",
                children: [
                    checkBoxUI,
                    childrenUI && /*#__PURE__*/ _jsx(CheckboxLabel, {
                        as: "label",
                        htmlFor: checkboxId,
                        level: "sm",
                        size: size,
                        disabled: Boolean(disabled),
                        "data-test-id": `${dataTestId}-label`,
                        children: childrenUI
                    })
                ]
            }),
            helpText && /*#__PURE__*/ _jsx(StyledHelpText, {
                children: helpText
            })
        ]
    });
    if (tooltip) {
        return renderWithTooltip(checkboxContent, tooltip);
    }
    return checkboxContent;
};
